import React from 'react';
import PropTypes from 'prop-types';
import * as MaterialCheckbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import './index.sass';

 const Checkbox = ({ label, required, checked, onChange, className }) => {
	const OrangeCheckbox = withStyles({
		root: {
			color: '#ffffff',
			'&$checked': {
				color: '#F57C00',
			},
		},
		checked: {},
	})(props => <MaterialCheckbox.default color="default" {...props} />);

	return (
		<div className={`Checkbox ${className}`}>
			<FormControlLabel
				control={
					<OrangeCheckbox
						checked={checked}
						required={required}
						onChange={(e) => onChange(e.target.checked)}
						value="checked"
					/>
				}
				label={label}
			/>
		</div>
	);
}

Checkbox.propTypes = {
	checked: PropTypes.bool,
	required: PropTypes.bool,
	onChange: PropTypes.func,
	className: PropTypes.string,
};

Checkbox.defaultProps = {
	checked: false,
	required: false,
	onChange: () => {},
	className: '',
};

export default Checkbox;
